import styled from 'styled-components';

import { theme } from './theme';
import { SpacingType, getCssPadding } from './spacing';

export const Content = styled.div<{ verticalPadding?: SpacingType; horizontalPadding?: SpacingType }>`
  padding: ${({ verticalPadding }) => getCssPadding('vertical', verticalPadding)}
    ${({ horizontalPadding }) => getCssPadding('horizontal', horizontalPadding)};
`;

export const Label = styled.div`
  padding: ${theme.padding.vertical} ${theme.padding.horizontal};
`;
